<div id="failPageWrap">
  <div id="fail_picture">
<!--    <embed src='{{assetsRoute}}/picture/feature/sorry.svg' type="image/svg+xml" width="100%" height="100%"/>-->
    <img src="{{assetsRoute}}/picture/feature/sorry.svg" alt="" />
  </div>

  <div id="wrap" class="fontSize16 lineHeight27">
      <span *ngIf="survey.type==1">很遗憾，由于你没有完成测验，我们无法为你生成报告。如果你还想了解自己的领导力DNA，我们建议你重新进行测验。</span>
      <span *ngIf="survey.type==2">很遗憾，由于你没有开始进行测验，我们无法为你生成报告。</span>
      <span *ngIf="survey.type==3">很遗憾，由于你没有开始进行测验，我们无法为你生成报告，你的学习旅程已经结束。</span>
  </div>

  <div id="buttonWrap" *ngIf="survey.type==1">
    <app-slide-button (onBegin)="restart();"  [text]="'重新开启测验'"></app-slide-button>
  </div>

  <div id="closeBtn" class="fontSize18" (click)="closeWindow();" [ngClass]="{'closeBtnBorder':survey.type!=1}">关闭本页面</div>
</div>




// WEBPACK FOOTER //
// ./src/app/fail/fail.component.html